import React, { useState } from 'react';
import { TextField } from '@mui/material';
import GetLangConfig from '../../util/LangUtil';
import './forgot.password.css';
import { DrugExceptionsClient } from '../../client/drug-exceptions-client';
import { useNavigate } from 'react-router-dom';

interface HandleError {
    handleError: Function;
}

export default function ForgotPassword(props: HandleError) {
    const [email, updateEmail] = useState('');
    const [loading, setLoading] = useState(false); // Track loading state
    const history = useNavigate();
    const langConfig = GetLangConfig('forgotPassword');

    const requestPasswordReset = async () => {
        if (!/\S+@\S+\.\S+/.test(email)) {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Please enter a valid email address.']
                    }
                }
            });
            return;
        }

        setLoading(true); // Set loading to true when request starts
        const drugExceptionsClient = new DrugExceptionsClient();
        try {
            const response = await drugExceptionsClient.api.post(
                '/users/forgotpassword',
                {
                    email,
                }
            );
            // Handle success response (if needed)
        } catch (error) {
            props.handleError(error);
        } finally {
            setLoading(false); // Set loading to false when request completes
        }
    };

    return (
        <div className="forgot-password-container">
            <h1>{langConfig.forgotPassword.header}</h1>
            <TextField
                id="email-address"
                label={langConfig.general.emailAddress}
                value={email}
                onChange={(e) => updateEmail(e.target.value)}
                error={email !== '' && !/\S+@\S+\.\S+/.test(email)}
                variant="filled"
                margin="normal"
                fullWidth
            />
            <div>
                <button
                    className={`mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped ${loading ? 'mdc-button--disabled' : ''}`}
                    onClick={requestPasswordReset}
                    disabled={loading} // Disable button when request is in flight
                >
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">
                        {langConfig.forgotPassword.resetBtn} {/* No change to button text */}
                    </span>
                </button>
            </div>
        </div>
    );
}
